/* Hook encargado de hacer la consulta a la base y 
traer los negocios )deals)

Autor: Benjamín León
Fecha: 2024-11-09
*/
import { useState } from 'react'

import { customFetch } from '../utils/customFetch.ts'
import Reservation from '../interfaces/Reservation.ts'

import { makeUrlReservationsDeal } from './connectionData.tsx'

const useReservationsDealFetcher = () => {
  const [errorReservationsDeal, setErrorReservationsDeal] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const fetchReservationsDeal = async (vehId: string, cliId: string) => {
    setLoading(true)

    const params = new URLSearchParams({
      vehId: vehId,
      cliId: cliId,
    })

    try {
      const apiUrl = makeUrlReservationsDeal(params)
      const array = await customFetch<Reservation[]>(apiUrl)

      setErrorReservationsDeal(null)

      return array
    } catch (err) {
      // Assert the error as an instance of Error
      const myErr = err instanceof Error ? err : new Error('An unknown error occurred')
      setErrorReservationsDeal(myErr)

      return []
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { loading, errorReservationsDeal, fetchReservationsDeal }
}
export default useReservationsDealFetcher
